<app-file-selection [(visible)]="fileSelectionVisible" [config]="fileSelectionConfig()" [fetch]="fileSelectionFetch"
    [dropdownOptions]="activeDropdownOptions()" [fileItemTemplate]="fileItemTemplate"
    [selectedFileTemplate]="selectedFileTemplate" (onSubmit)="onFileSelectionSubmit($event)"
    (onCancel)="onFileSelectionCancel()">

    <!-- Custom file item template -->
    <ng-template #fileItemTemplate let-file let-selected="selected" let-toggleSelection="toggleSelection">
        <div class="flex flex-row items-center gap-3">
            <app-checkbox [value]="selected" [config]="{ binary: true }" (onChange)="toggleSelection($event)" />

            <div class="flex flex-1 flex-row items-center gap-2 min-w-0">
                <app-file-icon [type]="getFileType(file.name)" size="xxl" />
                <div class="flex flex-col items-start gap-1 w-full">
                    <span class="font-semibold text-xs text-gray-900 truncate w-full" [pTooltip]="file.name"
                        tooltipPosition="bottom">{{
                        file.name
                        }}</span>
                    <div class="flex justify-between items-center w-full">
                        @if(file.metadata?.createdAt) {
                        <span class="text-xs text-gray-500 shrink-0">
                            {{ file.metadata.createdAt | dateFormatter }}
                        </span>
                        }
                        @if(file.metadata?.createdBy || file.metadata?.linkedBy) {
                        <app-user-name-display [user]="file.metadata?.createdBy || file.metadata?.linkedBy"
                            [variant]="'avatar-name'" [size]="'xs'"
                            [class]="'text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis shrink-0'"></app-user-name-display>
                        }

                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Custom selected file template (right panel) -->
    <ng-template #selectedFileTemplate let-file let-selected="selected" let-toggleSelection="toggleSelection">
        <div class="flex flex-row items-center gap-3">
            <div class="flex flex-1 flex-row items-center gap-2 min-w-0">
                <app-file-icon [type]="getFileType(file.name)" size="xxl" />
                <div class="flex flex-col items-start gap-1 w-full min-w-0">
                    <span class="font-semibold text-xs text-gray-900 truncate">{{ file.name }}</span>
                    <div class="flex justify-between items-center w-full min-w-0">
                        @if(file.metadata?.createdAt) {
                        <span class="text-xs text-gray-500">
                            {{ file.metadata.createdAt | dateFormatter }}
                        </span>
                        }
                    </div>
                </div>
                <app-button variant="outlined" severity="danger" icon="pi pi-trash" size="sm"
                    (clicked)="toggleSelection({ checked: false })" />
            </div>
        </div>
    </ng-template>
</app-file-selection>